
import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { DataServiceService } from '../data-service.service';
import { CampusTrackService } from '../campus-track.service';
import { Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-campusdialog',
  templateUrl: './campusdialog.component.html',
  styleUrls: ['./campusdialog.component.scss']
})
export class CampusdialogComponent implements OnInit {
  campusTrackdialog!: FormGroup;
  APPORVAL: any;
  REJECT: any;
  constructor(public dialogRef: MatDialogRef<CampusdialogComponent> ,  @Inject(MAT_DIALOG_DATA) public data: any,private services:CampusTrackService,public snackbar: MatSnackBar, private fb:FormBuilder, private spinner: NgxSpinnerService) {}




  // close(){
  //   if(this.data.approvalStatus=="APPROVED"){
  //     this.dialogRef.close('APPROVED');
  //   } else if(this.data.approvalStatus=="REJECTED"){
  //     this.dialogRef.close('REJECTED');
  //   }
  //   else{
  //     this.dialogRef.close('PENDING');
  //   }
  // }
  ngOnInit(): void {
    this.campusTrackdialog=this.fb.group({
      anyOtherReasons:["",Validators.required]
    })
  }
  approval(data:any){
    this.APPORVAL=data.campusTrackId
    console.log(this.APPORVAL);
    
    let data2={
      "approvalStatus":"APPROVED",
      "remarks": this.campusTrackdialog.value.anyOtherReasons
    }
this.services.getcampusapporvallist(this.APPORVAL,data2).subscribe((res:any)=>{
  res;
  console.log("updated data");
  this.dialogRef.close("pending");
  this.snackbar.open('Course Track Details approved Successfully ', 'Close', {
    duration: 2000,
    verticalPosition: 'top',
    horizontalPosition: 'end',
  });
})
this.dialogRef.close();
  }
  reject(data:any){
    this.APPORVAL=data.campusTrackId
    console.log(this.REJECT);
    let data2={
      "approvalStatus":"REJECTED",
      "remarks": this.campusTrackdialog.value.anyOtherReasons
    }
    this.services.getcampusapporvallist(this.APPORVAL,data2).subscribe((res:any)=>{
      res;
      console.log("updated data");
      this.dialogRef.close("pending");
      this.snackbar.open('Course Track Details approved Successfully ', 'Close', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'end',
      });
    
  })
  this.dialogRef.close();

}

}
